import * as types from "../../Action/actionTypes"

const initialState = {
  data: null,
  loading: false,
  error: null,
}

const signupReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SIGNUP_START:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case types.SIGNUP_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: null,
      }
    case types.SIGNUP_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    default:
      return state
  }
}

export default signupReducer
